import { TRIGGER_FETCH_BILL_DETAILS_API_SUCCESS } from 'redux/actionTypes';

const initialState = {};

// export const locale[];

const KYCDetailsReducer = (state = initialState, action) => {
	switch (action.type) {
		case TRIGGER_FETCH_BILL_DETAILS_API_SUCCESS:
			return {
				...state,
				...action.data,
			};
		default:
			return state;
	}
};

export default KYCDetailsReducer;
